import _ from 'lodash';
import useTranslation from "hooks/useTranslation";
import React, { useEffect, useState } from "react";
import { TimePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TextField, Tooltip, } from "@mui/material";
import { isValidDate } from "utils/date";
import { QueryBuilder, } from "@mui/icons-material";
import { makeStyles } from "tss-react/mui";
import { getDateValidation } from './validation';

const useStyles = makeStyles()(theme => ({
    contentContainer: {
        height: '75%',
    },
    noResultContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 8,
    },
    icon: {
        height: 100,
        width: 100,
    },
    iconError: {
        color: theme.palette.error.main,
    }
}));

const TimePickerCell = ({ initialValue, id, prop, updateTimesheet, }) => {
    const { classes } = useStyles();
    const { t } = useTranslation();
    const safeInitialValue = isValidDate(new Date(initialValue)) ? initialValue : new Date();
    const [value, setValue] = useState(safeInitialValue);
    const [error, setError] = useState('');

    useEffect(() => {
        if(initialValue !== value) {
            setValue(new Date(initialValue));
        }
        getDateValidation(t).validate(initialValue)
            .then(() => setError(''))
            .catch(error => setError(error.message))
    }, [initialValue]);
    
    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <TimePicker
                ampm={false}
                margin="normal"
                components={{
                    OpenPickerIcon: () => {
                        return ( error === '' 
                            ? <QueryBuilder/>
                            : (
                                <Tooltip title={error} placement="top">
                                    <QueryBuilder className={classes.iconError}/>
                                </Tooltip>
                            )
                        )
                    }
                }}
                OpenPickerButtonProps={{ tabIndex: -1 }}
                value={value}
                onChange={d => setValue(d)}
                onAccept={d => updateTimesheet(id, prop, new Date(d).toISOString())}
                renderInput={(params) => 
                    <TextField 
                        onFocus={e => e.target.select()}
                        error={error !== ''}
                        onBlur={e => {
                            let newDate = value;

                            if(isValidDate(new Date(newDate))) {
                                updateTimesheet(id, prop, new Date(newDate).toISOString());
                            } else {
                                updateTimesheet(id, prop, null);
                            }
                        }}
                        {...params} 
                        inputProps={{
                            ...params.inputProps,
                            style: { textAlign: 'right' }
                        }}
                    />
                }
            />
        </LocalizationProvider>
    );
};

export default TimePickerCell;